import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../styles/EscaypeHeatMap.css';
import {DeckGL} from '@deck.gl/react';
import {APIProvider, Map} from '@vis.gl/react-google-maps';
import {HeatmapLayer} from '@deck.gl/aggregation-layers';
import {_InfoWidget} from '@deck.gl/widgets';

function getHeatMapRadius(zoom) {
  /* 
  7 => 80,
  8 => 160
  9 => 320
  10 => 640*/

  return 80 * Math.pow(2, zoom - 7);
}

class EscaypeFogMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewState: {
        longitude: -122.419416,
        latitude: 37.774929,
        zoom: 7,
        maxZoom: 9,
        pitch: 0,
        bearing: 0
      }
    };
  }

  componentDidUpdate(prevProps) {
    // Check if marker position changed
    const { markerInfoWindowData } = this.props;
    const prevMarkerData = prevProps.markerInfoWindowData;
    
    if (markerInfoWindowData && 
        (!prevMarkerData || 
         markerInfoWindowData.obsLats !== prevMarkerData.obsLats || 
         markerInfoWindowData.obsLons !== prevMarkerData.obsLons)) {
      // Recenter the map on the new marker position
      this.setState({
        viewState: {
          ...this.state.viewState,
          longitude: markerInfoWindowData.obsLons,
          latitude: markerInfoWindowData.obsLats
        }
      });
    }
  }

  mapClicked = (info, event) => {
    // DeckGL click handler - info.coordinate is [lng, lat]
    if (info.coordinate) {
      const [lng, lat] = info.coordinate;
      this.props.onMarkerPositionChanged({lat, lng});
    }
  }
  

  getFogHeightString(fogTopMb) {
    let fogHeightString;

    //1000mb
    if (fogTopMb === 1000 || fogTopMb === 1025){
      fogHeightString = '<1000ft';
    }
    //975mb
    else if (fogTopMb === 975){
      fogHeightString = '1100-2000ft';
    }
    //950mb
    else if (fogTopMb === 950){
      fogHeightString = '2100-2700ft';
    }
    //925mb
    else if (fogTopMb === 925) {
      fogHeightString = '2800-3400ft';
    }
    //900mb
    else if (fogTopMb === 900) {
      fogHeightString = '>3500ft';
    }
    //no fog
    else if (fogTopMb === 0) {
      fogHeightString = 'no fog expected';
    }
    // error
    else {
      console.error(fogTopMb);
    }

    return fogHeightString;
  }

  render() {
    const { viewState } = this.state;
      // orange
    const fogGradient = [[255, 165, 0, 35], [255, 165, 0, 180]];
    // purple
    const lowFogGradient = [[158, 46, 207, 35], [158, 46, 207, 180]];

    const positions = this.props.heatMapData.map(element => {

      /*
      and it will give you a number from 900-1000 (which is the pressure)

      [4:55] 
      or 0 if there's no fog

      [4:56] 
      so i subtract 900 and divide the result by 100 to normalize it from 0 to 1, then make the heatmap (if it's <0, just set it to 0)
      */

      const weight = element.p_fog;

      return {
        lat: element.obsLats,
        lng: element.obsLons,
        weight: weight,
        fogTopMb: element.fogTopMb
      };
    }).filter(element => element.weight);

    const lowFogPositions = positions.filter(element => element.fogTopMb >= 1000);
    const otherPositions = positions.filter(element => element.fogTopMb < 1000);

    //const { markerInfoWindowData } = this.props;
    //const markerPosition = markerInfoWindowData ? {lat: markerInfoWindowData.obsLats, lng: markerInfoWindowData.obsLons} : null;
    //const infoWindowContent = markerInfoWindowData ? `<p>Fog height: ${this.getFogHeightString(markerInfoWindowData.fogTopMb)}, ${(markerInfoWindowData.p_fog * 100).toFixed(0)}% chance</p>` : null;

    let layers = [];       
    layers.push(
      new HeatmapLayer({
        data: otherPositions,
        id: 'heatmap-layer-fog',
        pickable: false,
        getPosition: d => [d.lng, d.lat],
        getWeight: d => d.weight,
        radiusPixels: getHeatMapRadius(viewState.zoom),
        intensity: 1,
        threshold: 0.03,
        colorRange: fogGradient
      }
    ));
    layers.push(
      new HeatmapLayer({
        data: lowFogPositions,
        id: 'heatmap-layer-low-fog',
        pickable: false,
        getPosition: d => [d.lng, d.lat],
        getWeight: d => d.weight,
        radiusPixels: getHeatMapRadius(viewState.zoom),
        intensity: 1,
        threshold: 0.03,
        colorRange: lowFogGradient
      }
    ));


    const { markerInfoWindowData } = this.props;
     let infoWidgets = [];
     if (markerInfoWindowData) {
      infoWidgets.push(new _InfoWidget({
        visible: true,
        mode: 'static',
        position: [markerInfoWindowData.obsLons, markerInfoWindowData.obsLats],
        text: `Fog height: ${this.getFogHeightString(markerInfoWindowData.fogTopMb)}, ${(markerInfoWindowData.p_fog * 100).toFixed(0)}% chance`,
        style: {color: 'black', backgroundColor: 'white', fontSize: 'small', width: '100px', whiteSpace: 'pre-wrap'}
      }));
     }

    return (
      <div style={{display: 'flex', flexDirection: 'column', height: '100%', width: '100%'}}>
        <div style={{flex: 1, width: '100%', height: 'calc(100vh - 180px)', position: 'relative'}}>
          <APIProvider apiKey="AIzaSyBvTyJVe_BpeXHzqilsM1Mp2nyJyGFvavE">
            <DeckGL 
              viewState={viewState} 
              controller={true}
              onViewStateChange={({viewState}) => this.setState({viewState})}
              onClick={this.mapClicked}
             layers={layers} 
              widgets={infoWidgets}
              style={{width: '100%', height: '100%'}}
            >
              <Map />
            </DeckGL>
          </APIProvider>
        </div>
      </div>
    );
  }
}

EscaypeFogMap.propTypes = {
  google: PropTypes.any,
  map: PropTypes.any,

  heatMapData: PropTypes.arrayOf(PropTypes.shape({
    fogTopMb: PropTypes.number.isRequired,
    obsLats: PropTypes.number.isRequired,
    obsLons: PropTypes.number.isRequired
  })).isRequired,
  markerInfoWindowData: PropTypes.shape({
    obsLats: PropTypes.number.isRequired,
    obsLons: PropTypes.number.isRequired,
    fogTopMb: PropTypes.number.isRequired
  }),
  onMarkerPositionChanged: PropTypes.func.isRequired
};

export default EscaypeFogMap;